import type { ProContractorRow } from "./parseProContractorRows";

const uniqueSortedMonthLabels = (rows: ProContractorRow[]): string[] => {
  const set = new Set(rows.map((r) => r.monthLabel));
  return Array.from(set).sort();
};

const uniqueSortedRegions = (rows: ProContractorRow[]): string[] => {
  const set = new Set(rows.map((r) => r.region));
  return Array.from(set).sort((a, b) => a.localeCompare(b, "pl"));
};

export const buildStackedRegionDatasets = (
  rows: ProContractorRow[],
): { labels: string[]; datasets: { label: string; data: number[] }[] } => {
  const months = uniqueSortedMonthLabels(rows);
  const regions = uniqueSortedRegions(rows);
  const lookup = new Map<string, Map<string, number>>();
  for (const row of rows) {
    if (!lookup.has(row.monthLabel)) {
      lookup.set(row.monthLabel, new Map());
    }
    const byMonth = lookup.get(row.monthLabel);
    if (byMonth === undefined) {
      continue;
    }
    byMonth.set(row.region, (byMonth.get(row.region) ?? 0) + row.count);
  }
  const datasets = regions.map((region) => ({
    label: region,
    data: months.map((m) => lookup.get(m)?.get(region) ?? 0),
  }));
  return { labels: months, datasets };
};
